import './App.css';
import {Route,Routes, Navigate } from "react-router-dom";
import Layout from './components/Layout';
import IndexPage from './components/Pages/IndexPage';
import LoginPage from './components/Pages/LoginPage';
import RegisterPage from './components/Pages/RegisterPage';
import { UserContextProvider } from './UserContext';
import CreatePost from './components/Pages/CreatePost';
import TrekDetailsPage from "./components/Pages/TrekDetailsPage.js";
import BookTrekPage from './components/Pages/BookView.js';
import HomePage from './components/Pages/HomePage';
import DisplayTreks from './components/Pages/DisplayTreks';
import ViewTreksPage from './components/Pages/ViewTreksPage';
import ViewParticipantsPage from './components/Pages/ViewParticipantsPage';
import EditTrek from './components/Pages/EditTrek';
import GalleryPage from './components/Pages/GalleryPage.js';
import ContactPage from './components/ContactPage.js';
import AboutUsPage from './components/Pages/AboutUsPage.js';
import OneDayTrekPage from './components/Pages/OneDayTrekPage.js';
import TwoDayTrekPage from './components/Pages/TwoDayTrekPage.js';
import '@fortawesome/fontawesome-free/css/all.css';
import ReleaseNotePage from './components/Pages/ReleaseNotePage.js';
import { useAuth } from '../src/authUtils.js';
import { useNavigate } from 'react-router-dom';
import NotFoundPage from './components/Pages/NotFoundPage.js';

function App() {
  const loggedIn = useAuth();
  const navigate = useNavigate();

  if (!loggedIn) {
    navigate('/page-not-found');
  }
  
  return (
    <UserContextProvider>
      <Routes>
        <Route path="/" element={<Layout />}>
        <Route index element={<IndexPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/home" element={<HomePage />} />
        <Route path="/about" element={<AboutUsPage />} />
        <Route path="/gallery" element={<GalleryPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/one-day-trek" element={<OneDayTrekPage />} />
        <Route path="/two-day-trek" element={<TwoDayTrekPage />} />
        <Route path="/trekDetails/:id" element={<TrekDetailsPage />} />
        <Route path="/bookTrek/:id" element={<BookTrekPage />} />
        <Route path="/displayAllTreks" element={<DisplayTreks />} />
        <Route path="/release-notes" element={<ReleaseNotePage />} />
        <Route path="/admin/login" element={<LoginPage />} />
        {loggedIn ? (
          <>
            <Route path="/admin/dashboard" element={<ViewTreksPage />} />
            <Route path="admin/viewAllParticipants/:trekId" element={<ViewParticipantsPage />} />
            <Route path="admin/editTrek/:id" element={<EditTrek />} />
            <Route path="/admin/addNewTrek" element={<CreatePost />} />
          </>
          ) : (
          <></>
        )}
        <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes>
    </UserContextProvider>
  );
}

export default App;
